import {
  GET_PURCHASE_STATUS_LIST,
  GET_PURCHASE_KEYWORD_LIST,
  PURCHASE_LIST_ACTION,
} from "./action";
import { PURCHASE_STATUS_LIST_MUTATION, PURCHASE_KEYWORD_LIST_MUTATION } from "./mutation";
import ApiService from "@/services/ApiService";
import apiPath from "@/services/apiPath";

export default {
  state: {
    statusList: [],
    keywordList: [],
  },
  actions: {
    async [GET_PURCHASE_STATUS_LIST](context) {
      //품목관리 상태
      if (context.state.statusList.length > 0) return; // 한번만 호출.
      //const result = await ApiService.shared.getData(apiPath.ITEM_STATUS_LIST); //API가 없어서 front에서 하드코딩함
      const result = {
        code: "",
        data: [
          { id: "", code: "", desc: "전체" },
          { id: "N", code: "N", desc: "접수대기" },
          { id: "C", code: "C", desc: "반려" },
          { id: "M", code: "M", desc: "재고지급" },
          { id: "S", code: "S", desc: "접수완료" },
          { id: "F", code: "F", desc: "구매완료" },
        ],
        text: "",
      };
      const { code, data, text } = result;
      this.commit({
        type: PURCHASE_STATUS_LIST_MUTATION,
        list: data || [],
      });
    },
    async [GET_PURCHASE_KEYWORD_LIST](context) {
      //품목관리 검색어
      if (context.state.keywordList.length > 0) return; // 한번만 호출.
      //const result = await ApiService.shared.getData(apiPath.ITEM_KEYWORD_LIST); //API가 없어서 front에서 하드코딩함
      const result = {
        code: "",
        data: [
          // { id: "projectName", code: "projectName", desc: "프로젝트명" },
          { id: "requester", code: "requester", desc: "구매요청자" },
          { id: "purchase", code: "purchase", desc: "구매담당자" },
          { id: "title", code: "title", desc: "구매요청명" },
          { id: "itemName", code: "itemName", desc: "품목명" },
        ],
        text: "",
      };
      const { code, data, text } = result;
      this.commit({
        type: PURCHASE_KEYWORD_LIST_MUTATION,
        list: data || [],
      });
    },

    async [PURCHASE_LIST_ACTION](context) {
      await context.dispatch(GET_PURCHASE_STATUS_LIST);
      await context.dispatch(GET_PURCHASE_KEYWORD_LIST);
    },
  },
  mutations: {
    [PURCHASE_STATUS_LIST_MUTATION](state, payload) {
      //품목관리 상태
      const { list } = payload;
      state.statusList = Object.freeze(
        list.map((item, index) => Object.freeze({ ...item, index: index })),
      );
    },
    [PURCHASE_KEYWORD_LIST_MUTATION](state, payload) {
      //품목관리 검색어
      const { list } = payload;
      state.keywordList = Object.freeze(
        list.map((item, index) => Object.freeze({ ...item, index: index })),
      );
    },
  },
};
